import React, { Component } from 'react';

import { Label, Headline, Button } from '../../theme';
import { Slider, Slide } from '../../carousel';
import { Washing } from '../../svg';
import { isMobile } from '../../util';


class WashinProblem extends Component {
  render() {
    return (
      <div id="Rufe" className="container__fluid">
        <div className="w__flex w__flex-row Justify-between w__flex-column__mobile">

          <div className="w__flex w__flex-column carousel Justify-between Align-center o-2__mobile Align-right__mobile">
            <Slider device="rufe">

              <Slide
                text="O masina de spalat rufe cu capacitate de 5 kg consuma in medie 148 kWh/an? Una de 9 kg, cu doar 47 kWh mai mult."
              />

              <Slide
                text="Atunci cand folosesti un detergent performant, poti alege o temperatura mai scazuta a apei la spalare, iar asta te va ajuta sa consumi mai putina energie electrica?"
              />

            </Slider>
            <Button enel >
              <span className="mobile__hidden">Vezi</span>  oferta enel
            </Button>
          </div>

          <div className="w__flex w__flex-column Align-right problem__content">
            {
              !isMobile && (
                <div className="family">
                  <Washing.Family />
                </div>
              )
            }
            <Label marginRight="5.5vw" background="#840050" >
              problema mamei
            </Label>
            <Headline padding="5.5vw" large alignRight >
              <p style={{ color: '#840050' }}>SPAL DES <span style={{ color: '#d33c64' }}>PENTRU </span></p>
              <p style={{ color: '#d33c64' }}>CA MASINA SE</p>
              <p style={{ color: '#d33c64' }}>UMPLE REPEDE<span className="punctuation">...</span></p>
            </Headline>
            <div className="couch">
              <Washing.Couch />
            </div>
          </div>

        </div>
      </div>
    );
  }
}

export default WashinProblem;


// WEBPACK FOOTER //
// ./src/components/pages/Rufe/WashingProblem.jsx